import { registerDecorators as _registerDecorators, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./loginView.html";
// import {track, LightningElement} from 'lwc';

import LightningElementSLDS from 'util/lightningElementSLDS';
class LoginView extends LightningElementSLDS {
  constructor(...args) {
    super(...args);
    // @track apiKey = "EJSkN/zy/NjrPovF7ohjLseun9xgA5bytFNPbPR+MXrF+e+EODWJUg==";
    this.apiKey = "iAk7tPw1CVdjHaiX/DxfeUHdfmwi5hn6RKbtB04VVpx2ixXivfgpfw==";
    this.username = "";
    this.password = "";
  }
  connectedCallback() {
    // window.console.log("Simulating login for now...");
    // // For now, there is no authentication to be done, so just simulate a login.
    // let elem = document.querySelector('zpaper-app');
    // let event = new CustomEvent('zippi-login-successful', {bubbles: true, cancelable: true});
    // elem.dispatchEvent(event);
  }
  handleClick() {
    console.log("handling the login form submission click");
    let akey = this.apiKey.replace(/[+]/g, '%2B');
    let body = `apikey=${akey}&username=${this.username}&password=${this.password}`;
    console.log("body = ", body);
    // debugger;
    let elem = document.querySelector('zpaper-app');
    console.log('elem = ' + elem);
    let event = new CustomEvent('zippi-login-successful', {
      bubbles: true,
      cancelable: true
    });
    elem.dispatchEvent(event);
    // fetch("http://localhost:3002/api/zippi/login", {
    //     method: "POST",
    //     headers: {
    //         "content-type": "application/x-www-form-urlencoded"
    //     },
    //     body: body
    // }).then(res => {
    //     debugger;
    //     console.log("Response code from zippi login: " + res.status);
    //     if (200 === res.status) {
    //         let elem = document.querySelector('zpaper-app');
    //         console.log('elem = ' + elem);
    //         let event = new CustomEvent('zippi-login-successful', {bubbles: true, cancelable: true});
    //         elem.dispatchEvent(event);
    //         // this.dispatchEvent(new CustomEvent('zippi-login-successful'), {bubbles: true, cancelable: true});
    //     }
    // }).catch(error => {
    //     debugger;
    //     console.log('error => ' + error);
    // });
  }
  handleChange(event) {
    // Save the name=value of the input field to this component
    this[event.target.name] = event.target.value;
    console.log("Field matching", event.target.name, "=>", this[event.target.name]);
  }
}
_registerDecorators(LoginView, {
  track: {
    apiKey: 1,
    username: 1,
    password: 1
  }
});
export default _registerComponent(LoginView, {
  tmpl: _tmpl
});